import React, { useEffect, useRef } from 'react';
import { Card, CardContent } from './ui/card';
import { Users, GraduationCap } from 'lucide-react';

export const TeamCeo = () => {
  const teamRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add('scale-in');
            }, index * 150);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = teamRef.current?.querySelectorAll('.team-card');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  const teamMembers = [
    {
      name: 'Dr. Abhijeet Tiwade',
      specialty: 'CEO & CMO',
      image: '/images/abhijeet.jpg',
      credentials: 'MBBS',
    },
  ];

  return (
    <section className="py-24 bg-[hsl(var(--muted))]" ref={teamRef}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <div className="inline-flex items-center space-x-2 bg-[hsl(var(--primary))]/10 px-4 py-2 rounded-full">
            <Users className="w-5 h-5 text-[hsl(var(--primary))]" />
            <span className="text-sm font-semibold text-[hsl(var(--primary))]">
           
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-[hsl(var(--foreground))]">
            Meet Our <span className="block mt-2 text-gradient">CEO</span>
          </h2>
          <p className="text-lg text-[hsl(var(--muted-foreground))] max-w-2xl mx-auto">
           Meet our Chief Executive Officer and Chief Medical Officer who bridge visionary leadership with medical excellence.
          </p>
        </div>

        {/* Centered Team Grid */}
        <div className="flex justify-center">
          <div className="grid grid-cols-1 md:grid-cols-1 max-w-md">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="team-card opacity-0"
                style={{ transitionDelay: `${index * 150}ms` }}
              >
                <Card className="group overflow-hidden hover:shadow-[var(--shadow-xl)] transition-all duration-500 border-none h-full flex flex-col">
                  {/* Image */}
                  <div className="relative h-80 overflow-hidden flex-shrink-0">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--foreground))]/10 via-[hsl(var(--foreground))]/20 to-transparent"></div>
                  </div>

                  {/* Info - Centered and Clean */}
                  <CardContent className="p-6 text-center flex-grow flex flex-col justify-center">
                    <div className="space-y-3">
                      <h3 className="text-xl font-bold text-[hsl(var(--foreground))]">
                        {member.name}
                      </h3>
                      <div className="flex items-center justify-center space-x-2 text-[hsl(var(--primary))]">
                        <GraduationCap className="w-4 h-4" />
                        <span className="font-medium">{member.credentials}</span>
                      </div>
                      <div className="px-4 py-2 rounded-full bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] text-sm font-medium inline-block">
                        {member.specialty}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <Card className="max-w-3xl mx-auto bg-gradient-to-r from-[hsl(var(--primary))]/5 to-[hsl(var(--secondary))]/5 border-2 border-[hsl(var(--primary))]/20">
            <CardContent className="py-12 px-6">
              <h3 className="text-2xl font-bold text-[hsl(var(--foreground))] mb-3">
                Join Our Growing Medical Family
              </h3>
              <p className="text-[hsl(var(--muted-foreground))] mb-6">
                We're always looking for talented healthcare professionals to join our team
              </p>
              <button
                onClick={() => {
                  const element = document.querySelector('#contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center space-x-2 text-[hsl(var(--primary))] font-semibold hover:text-[hsl(var(--primary-dark))] transition-colors group"
              >
                <span>Contact Us for Career Opportunities</span>
                <svg
                  className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};